import { Component, Input } from '@angular/core';
import { Staff } from '@app/models/staff.model';

@Component({
  selector: 'app-staff-item',
  templateUrl: './staff-item.component.html',
  styleUrls: ['./staff-item.component.scss'],
})
export class StaffItemComponent {
  @Input() staff!: Staff;
  @Input() multiSeletect: boolean = false;
  @Input() selected: boolean = false;
  @Input() disabled: boolean = false;

  constructor() {
  }
}
